import React from 'react';
import classNames from 'classnames';
import { PaintSwatches } from '@one-thd/sui-icons';
import Image from '../../common/Image';
import { paintManualImagePropTypes, paintManualImageDefaultProps } from '../propTypes';

const PaintManualImage = ({ asset, alt }) => {
  if (!asset) return null;
  const manualColorStyle = classNames(
    'manualSwatch',
    'sui-aspect-square',
    'sui-bg-inactive',
    'sui-flex',
    'sui-items-center',
    'sui-justify-center'
  );
  return (
    <div className={manualColorStyle}>
      <div className="sui-text-center sui-flex sui-items-center sui-justify-center">
        <div>
          <PaintSwatches color="medium" />
          <div>No Color Preview Available</div>
        </div>
      </div>
      <div className="w-full h-auto aspect-square max-w-full flex items-end sui-absolute">
        <Image
          alt={alt}
          src={asset?.brandLogo}
        />
      </div>
    </div>
  );
};

PaintManualImage.propTypes = paintManualImagePropTypes;
PaintManualImage.defaultProps = paintManualImageDefaultProps;

export default PaintManualImage;